@if(processando) {
<div class="loading-overlay">
  <mat-progress-spinner
    mode="indeterminate"
    color="primary"
  ></mat-progress-spinner>
</div>
}

<!-- EMPRESA PICKER -->
<app-empresa-picker
  (selecaoChange)="onSelecaoAlterada($event)"
></app-empresa-picker>

<!-- PESSOA PICKER -->
<section>
  <mat-form-field
    appearance="outline"
    class="full-width"
    [class.error]="
      touchedPessoa && empresaSelecionada && enderecoSelecionado
    "
  >
    <mat-label>Vincular pessoa*</mat-label>
    <input
      matInput
      type="text"
      [value]="pessoaSelecionada?.nomeCompleto || ''"
      readonly
      [disabled]="!empresaSelecionada || !enderecoSelecionado || pessoaSelecionada"
      (click)="abrirModalPessoasEndereco()"
      [ngStyle]="
        empresaSelecionada && enderecoSelecionado && !pessoaSelecionada
          ? { cursor: 'pointer' }
          : {}
      "
    />
  </mat-form-field>

  <p
    *ngIf="touchedPessoa && empresaSelecionada && enderecoSelecionado && !pessoaSelecionada"
    class="erro"
  >
    É obrigatório selecionar uma pessoa
  </p>

  <div class="pessoa-selecionada-card" *ngIf="pessoaSelecionada">
    <p>{{ pessoaSelecionada.nomeCompleto }}</p>

    @if(!formBloqueado()) {
    <img
      src="../../../../assets/svg/icons/trash.svg"
      (click)="abriDesvincularPessoa()"
      style="cursor: pointer"
    />
    }
  </div>
</section>

<!-- PRESENÇA DE CARGA -->
<section class="radio-section">
  <!-- <div class="spacer" style="height: 20px"></div>
  <p class="section-title">INFORMAÇÕES EXTRAS</p> -->
  <div class="radio-container">
    <span class="radio-main-label">Presença de carga:</span>

    <mat-radio-group
      [(ngModel)]="cargaSelecionada"
      [disabled]="formBloqueado()"
      class="radio-group"
    >
      <mat-radio-button
        *ngFor="let n of cargaOptions"
        [value]="n"
        class="custom-radio"
      >
        {{ n }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</section>

<div style="height: 20px"></div>

<!-- Seção: Upload de Arquivo -->
<section class="form-section">
  <p class="section-title">ARQUIVO DE IMPORTAÇÃO</p>

  <!-- Input de Arquivo -->
  <div class="upload-area">
    <input
      type="file"
      id="fileInput"
      accept=".mp4,.avi,.mov,video/mp4,video/x-msvideo,video/quicktime"
      (change)="onArquivoSelecionado($event)"
      [disabled]="processando"
      hidden
    />

    <!-- Área de upload quando não há arquivo -->
    <div
      *ngIf="!arquivoSelecionado()"
      class="upload-placeholder"
      [class.error]="touchedArquivo && !arquivoSelecionado()"
      (click)="!processando && abrirSeletorArquivo()"
      [style.cursor]="processando ? 'not-allowed' : 'pointer'"
    >
      <mat-icon class="upload-icon">cloud_upload</mat-icon>
      <p class="upload-text">
        Clique para selecionar ou arraste o arquivo aqui
      </p>
      <p class="upload-hint">
        Apenas arquivos .mp4, .avi ou .mov (máximo 600MB)
      </p>
    </div>

    <!-- Card do arquivo selecionado -->
    <div *ngIf="arquivoSelecionado()" class="arquivo-selecionado">
      <div class="arquivo-content">
        <mat-icon class="arquivo-icon">video_file</mat-icon>
        <div class="arquivo-info">
          <p class="arquivo-nome">{{ arquivoSelecionado()?.name }}</p>
          <p class="arquivo-tamanho">
            {{ formatarTamanhoArquivo(arquivoSelecionado()?.size || 0) }}
          </p>
        </div>
        <button
          mat-icon-button
          (click)="removerArquivo()"
          [disabled]="processando"
          class="btn-remover"
          *ngIf="!formBloqueado()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>

    <!-- Mensagem de erro de arquivo -->
    <p *ngIf="touchedArquivo && !arquivoSelecionado()" class="error-message">
      Arquivo obrigatório
    </p>
  </div>
</section>
<section class="actions">
  <button matButton="filled" color="primary" type="button" (click)="salvar()">
    Enviar
  </button>
</section>
